<!-- 报表管理 -->
<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" :class="{active: activeTab === tab.label}" @click="switchTab(tab)">{{ tab.label }}</span>
      </div>
      <button type="button" class="refresh-btn" @click="onRefresh">刷新</button>
    </div>
    
    <!-- 设备使用周报/月报 -->
    <div v-if="activeTab==='设备使用周报/月报'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>报表类型</label>
              <select class="form-input" v-model="deviceForm.reportType">
                <option value="">请选择</option>
                <option value="WEEKLY">周报</option>
                <option value="MONTHLY">月报</option>
              </select>
            </div>
            <div class="form-item">
              <label>设备ID：</label>
              <!-- 模仿报表类型的下拉框，使用select multiple -->
              <select class="form-input" v-model="deviceForm.deviceIds" multiple size="1">
                <option value="">全部设备</option>
                <option v-for="device in deviceOptions" 
                        :key="device.deviceId" 
                        :value="device.deviceId">
                  {{ device.deviceName }}（{{ device.deviceId }}）
                </option>
              </select>
            </div>
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="deviceForm.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="deviceForm.endDate" placeholder="" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="searchDeviceForm">搜索</button>
            <button type="button" class="clear-btn" @click="clearDeviceForm">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 汇总数据 - 直接从接口获取，不进行计算 -->
      <div class="data-section" v-if="deviceUsageSummary">
        <div style="padding: 10px; background: #f5f5f5; border-radius: 4px; margin-bottom: 10px;">
          <h4 style="margin: 0 0 8px 0;">{{ deviceUsagePeriod }} 汇总</h4>
          <div style="display: flex; justify-content: center; gap: 20px; flex-wrap: wrap;">
            <span>总使用次数：{{ deviceUsageSummary.totalUsageCount }} 次</span>
            <span>总使用时长：{{ deviceUsageSummary.totalUsageTimeMinutes }} 分钟</span>
            <span>平均使用率：{{ deviceUsageSummary.avgUsageRate }} %</span>
            <span>总故障次数：{{ deviceUsageSummary.totalFaultCount }} 次</span>
            <span>平均故障率：{{ deviceUsageSummary.avgFaultRate }} %</span>
          </div>
        </div>
      </div>
      
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>设备ID</th>
                <th>设备编号</th>
                <th>设备名称</th>
                <th>安装位置</th>
                <th>使用次数（次）</th>
                <th>使用时长（分钟）</th>
                <th>使用率（%）</th>
                <th>故障次数（次）</th>
                <th>故障率（%）</th>
                <th>空闲时长（分钟）</th>
                <th>平均使用时长（分钟）</th>
              </tr>
            </thead>
            <tbody>
              <!-- 加载中状态 -->
              <tr v-if="loading1">
                <td colspan="12" style="text-align:center;color:#bbb;">数据加载中...</td>
              </tr>
              <!-- 有数据时显示数据行 -->
              <template v-else-if="deviceUsageList.length > 0">
                <tr v-for="(item, index) in deviceUsageList" :key="item.deviceId">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.deviceId }}</td>
                  <td>{{ item.deviceNo }}</td>
                  <td>{{ item.deviceName }}</td>
                  <td>{{ item.location }}</td>
                  <td>{{ item.usageCount }}</td>
                  <td>{{ item.usageTimeMinutes }}</td>
                  <td>{{ item.usageRate }}</td>
                  <td>{{ item.faultCount }}</td>
                  <td>{{ item.faultRate }}</td>
                  <td>{{ item.idleTimeMinutes }}</td>
                  <td>{{ item.avgUsageDurationMinutes }}</td>
                </tr>
              </template>
              <!-- 无数据时显示暂无数据 -->
              <tr v-else>
                <td colspan="12" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    
    <!-- 用户行为周报/月报 -->
    <div v-else-if="activeTab==='用户行为周报/月报'">
      <!-- 筛选区 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="userBehaviorForm.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="userBehaviorForm.endDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>报表类型</label>
              <select class="form-input" v-model="userBehaviorForm.reportType">
                <option value="">请选择</option>
                <option value="WEEKLY">周报</option>
                <option value="MONTHLY">月报</option>
              </select>
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="getUserBehavior">搜索</button>
            <button type="button" class="clear-btn" @click="clearUserBehaviorForm">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 汇总数据（有数据才显示） -->
      <div class="data-section" v-if="userBehaviorData">
        <div style="padding: 10px; background: #f5f5f5; border-radius: 4px; margin-bottom: 10px;">
          <h4 style="margin: 0 0 8px 0;">{{ userBehaviorData.period }} 汇总</h4>
          <div style="display: flex; justify-content: center; gap: 20px; flex-wrap: wrap;">
            <span>总用户数：{{ userBehaviorData.totalUsers }} 人</span>
            <span>活跃用户数：{{ userBehaviorData.activeUsers }} 人</span>
            <span>正常用户数：{{ userBehaviorData.normalUsers }} 人</span>
            <span>违规用户数：{{ userBehaviorData.violationUsers }} 人</span>
            <span>违规率：{{ userBehaviorData.violationRate }} %</span>
          </div>
        </div>
      </div>
      
      <!-- 违规详情表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>违规类型</th>
                <th>违规次数（次）</th>
                <th>占比（%）</th>
              </tr>
            </thead>
            <tbody>
              <!-- 加载中状态 -->
              <tr v-if="loading2">
                <td colspan="4" style="text-align:center;color:#bbb;">数据加载中...</td>
              </tr>
              <!-- 有数据时显示数据行 -->
              <template v-else-if="userBehaviorData && userBehaviorData.violationDetails && userBehaviorData.violationDetails.length > 0">
                <tr v-for="(item, index) in userBehaviorData.violationDetails" :key="item.violationType">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.violationTypeName }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.percentage }}</td>
                </tr>
              </template>
              <!-- 无数据时显示暂无数据 -->
              <tr v-else>
                <td colspan="4" style="text-align:center;color:#bbb;">暂无违规数据</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 订单分析周报/月报 -->
    <div v-else-if="activeTab==='订单分析周报/月报'">
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="orderAnalysisForm.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="orderAnalysisForm.endDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>报表类型</label>
              <select class="form-input" v-model="orderAnalysisForm.reportType">
                <option value="">请选择</option>
                <option value="WEEKLY">周报</option>
                <option value="MONTHLY">月报</option>
              </select>
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="getOrderAnalysis">搜索</button>
            <button type="button" class="clear-btn" @click="clearOrderAnalysisForm">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 汇总数据（有数据才显示） -->
      <div class="data-section" v-if="orderAnalysisData">
        <div style="padding: 10px; background: #f5f5f5; border-radius: 4px; margin-bottom: 10px;">
          <h4 style="margin: 0 0 8px 0;">{{ orderAnalysisData.period }} 汇总</h4>
          <div style="display: flex;  justify-content: center; gap: 20px; flex-wrap: wrap;">
            <span>总订单数：{{ orderAnalysisData.totalOrders }} 单</span>
            <span>完成订单数：{{ orderAnalysisData.completedOrders }} 单</span>
            <span>取消订单数：{{ orderAnalysisData.cancelledOrders }} 单</span>
            <span>完成率：{{ orderAnalysisData.completionRate }} %</span>
            <span>订单高峰：{{ orderAnalysisData.peakHours ? orderAnalysisData.peakHours.join('、') : '' }}</span>
          </div>
        </div>
      </div>
      
      <!-- 程序偏好表格 -->
      <div class="data-section" style="margin-bottom: 20px;">
        <div class="table-container">
          <h5>程序偏好分析</h5>
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>程序名称</th>
                <th>时长（分钟）</th>
                <th>使用次数（次）</th>
                <th>占比（%）</th>
              </tr>
            </thead>
            <tbody>
              <!-- 加载中状态 -->
              <tr v-if="loading3">
                <td colspan="5" style="text-align:center;color:#bbb;">数据加载中...</td>
              </tr>
              <!-- 有数据时显示数据行 -->
              <template v-else-if="orderAnalysisData && orderAnalysisData.programPreference && orderAnalysisData.programPreference.length > 0">
                <tr v-for="(item, index) in orderAnalysisData.programPreference" :key="item.programName">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.programName }}</td>
                  <td>{{ item.durationMinutes }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.percentage }}</td>
                </tr>
              </template>
              <!-- 无数据时显示暂无数据 -->
              <tr v-else>
                <td colspan="5" style="text-align:center;color:#bbb;">暂无程序偏好数据</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <!-- 取消原因表格 -->
      <div class="data-section">
        <div class="table-container">
          <h5>取消原因分析</h5>
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>取消原因</th>
                <th>次数（次）</th>
                <th>占比（%）</th>
              </tr>
            </thead>
            <tbody>
              <!-- 加载中状态 -->
              <tr v-if="loading3">
                <td colspan="4" style="text-align:center;color:#bbb;">数据加载中...</td>
              </tr>
              <!-- 有数据时显示数据行 -->
              <template v-else-if="orderAnalysisData && orderAnalysisData.cancelReasons && orderAnalysisData.cancelReasons.length > 0">
                <tr v-for="(item, index) in orderAnalysisData.cancelReasons" :key="item.reason">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.reason }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.percentage }}</td>
                </tr>
              </template>
              <!-- 无数据时显示暂无数据 -->
              <tr v-else>
                <td colspan="4" style="text-align:center;color:#bbb;">暂无取消订单数据</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 投诉分析周报/月报 -->
    <div v-else-if="activeTab==='投诉分析周报/月报'">
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="complaintAnalysisForm.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="complaintAnalysisForm.endDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>报表类型</label>
              <select class="form-input" v-model="complaintAnalysisForm.reportType">
                <option value="">请选择</option>
                <option value="WEEKLY">周报</option>
                <option value="MONTHLY">月报</option>
              </select>
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="getComplaintAnalysis">搜索</button>
            <button type="button" class="clear-btn" @click="clearComplaintAnalysisForm">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 汇总数据（有数据才显示） -->
      <div class="data-section" v-if="complaintAnalysisData">
        <div style="padding: 10px; background: #f5f5f5; border-radius: 4px; margin-bottom: 10px;">
          <h4 style="margin: 0 0 8px 0;">{{ complaintAnalysisData.period }} 汇总</h4>
          <div style="display: flex; justify-content: center; gap: 20px; flex-wrap: wrap;">
            <span>总投诉数：{{ complaintAnalysisData.totalComplaints }} 件</span>
            <span>投诉率：{{ complaintAnalysisData.complaintRate }} %</span>
            <span>已解决：{{ complaintAnalysisData.processResult ? complaintAnalysisData.processResult.resolved : 0 }} 件</span>
            <span>已驳回：{{ complaintAnalysisData.processResult ? complaintAnalysisData.processResult.rejected : 0 }} 件</span>
            <span>处理中：{{ complaintAnalysisData.processResult ? complaintAnalysisData.processResult.pending : 0 }} 件</span>
            <span>平均处理时长：{{ complaintAnalysisData.avgProcessTimeHours }} 小时</span>
          </div>
        </div>
      </div>
      
      <!-- 投诉类型分布表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>投诉类型</th>
                <th>投诉次数（次）</th>
                <th>占比（%）</th>
              </tr>
            </thead>
            <tbody>
              <!-- 加载中状态 -->
              <tr v-if="loading4">
                <td colspan="4" style="text-align:center;color:#bbb;">数据加载中...</td>
              </tr>
              <!-- 有数据时显示数据行 -->
              <template v-else-if="complaintAnalysisData && complaintAnalysisData.typeDistribution && complaintAnalysisData.typeDistribution.length > 0">
                <tr v-for="(item, index) in complaintAnalysisData.typeDistribution" :key="item.complaintType">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.complaintTypeName }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.percentage }}</td>
                </tr>
              </template>
              <!-- 无数据时显示暂无数据 -->
              <tr v-else>
                <td colspan="4" style="text-align:center;color:#bbb;">暂无投诉数据</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 导出综合报表 -->
    <div v-else-if="activeTab==='导出综合报表'">
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields">
            <div class="form-item">
              <label>报表分类</label>
              <select class="form-input" v-model="exportForm.reportCategory">
                <option value="">请选择</option>
                <option value="DEVICE_USAGE">设备使用统计</option>
                <option value="USER_BEHAVIOR">用户行为分析</option>
                <option value="ORDER_ANALYSIS">订单分析</option>
                <option value="COMPLAINT_ANALYSIS">投诉分析</option>
                <option value="COMPREHENSIVE">综合报表</option>
              </select>
            </div>
            <div class="form-item">
              <label>报表类型</label>
              <select class="form-input" v-model="exportForm.reportType">
                <option value="">请选择</option>
                <option value="WEEKLY">周报</option>
                <option value="MONTHLY">月报</option>
              </select>
            </div>
            <div class="form-item">
              <label>文件格式</label>
              <select class="form-input" v-model="exportForm.format">
                <option value="">请选择</option>
                <option value="EXCEL">EXCEL</option>
                <option value="CSV">CSV</option>
              </select>
            </div>
            <div class="form-item">
              <label>开始日期：</label>
              <input class="form-input" type="date" v-model="exportForm.startDate" placeholder="" />
            </div>
            <div class="form-item">
              <label>结束日期：</label>
              <input class="form-input" type="date" v-model="exportForm.endDate" placeholder="" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="exportComprehensiveReport">立即导出</button>
            <button type="button" class="clear-btn" @click="clearExportForm">清空</button>
          </div>
        </form>
      </div>
      
      <!-- 导出记录提示 -->
      <div class="data-section" v-if="exportFileInfo">
        <div style="padding: 15px; background: #e8f5e9; border-radius: 4px; color: #2e7d32; text-align: center;">
          <h4 style="margin: 0 0 10px 0;">导出成功</h4>
          <p>文件名称：{{ exportFileInfo.fileName }}</p>
          <p>过期时间：{{ exportFileInfo.expiresAt }}</p>
          <button class="btn btn-edit" style="margin-top: 10px;" @click="downloadFile">重新下载</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDeviceUsageReportAll,
  getUserBehaviorReport,
  getOrderAnalysisReport,
  getComplaintAnalysisReport,
  exportReport,
  listDevices
} from '@/api/laundry.js';

// 导入日期验证工具函数
import { validateDateRange } from '@/api/dateValidator';

export default {
  name: 'LaundryReportManagement',
  data() {
    return {
      // 标签页配置
      tabs: [
        { label: '设备使用周报/月报' },
        { label: '用户行为周报/月报' },
        { label: '订单分析周报/月报' },
        { label: '投诉分析周报/月报' },
        { label: '导出综合报表' }
      ],
      activeTab: '设备使用周报/月报',
      loading1: false, 
      loading2: false, 
      loading3: false, 
      loading4: false, 
      loading5: false, 

      // 设备查询参数
      deviceQuery: {
        pageNo: 1,
        pageSize: 100
      },
      
      // 1. 设备使用报表
      deviceForm: {
        reportType: '',
        deviceIds: [], // 数组，支持多选
        startDate: '',
        endDate: ''
      },
      deviceUsageList: [],
      deviceUsageSummary: null,
      deviceUsagePeriod: '',
      deviceOptions: [],
      
      // 2. 用户行为报表
      userBehaviorForm: {
        reportType: '',
        startDate: '',
        endDate: ''
      },
      userBehaviorData: null,
      
      // 3. 订单分析报表
      orderAnalysisForm: {
        reportType: '',
        startDate: '',
        endDate: ''
      },
      orderAnalysisData: null,
      
      // 4. 投诉分析报表
      complaintAnalysisForm: {
        reportType: '',
        startDate: '',
        endDate: ''
      },
      complaintAnalysisData: null,
      
      // 5. 导出综合报表
      exportForm: {
        reportCategory: '',
        reportType: '',
        startDate: '',
        endDate: '',
        format: ''
      },
      exportFileInfo: null,// 导出文件信息
      
      // 防抖计时器
      debounceTimer: null
    };
  },
  created() {
    this.initPage();
    this.loadDeviceOptions();
  },

  watch: {
    // 监听设备表单的日期变化
    'deviceForm.startDate'(newVal, oldVal) {
      if (newVal !== oldVal && this.deviceForm.endDate) {
        this.debounceValidateDate('device');
      }
    },
    'deviceForm.endDate'(newVal, oldVal) {
      if (newVal !== oldVal && this.deviceForm.startDate) {
        this.debounceValidateDate('device');
      }
    },
    
    // 监听用户行为表单的日期变化
    'userBehaviorForm.startDate'(newVal, oldVal) {
      if (newVal !== oldVal && this.userBehaviorForm.endDate) {
        this.debounceValidateDate('userBehavior');
      }
    },
    'userBehaviorForm.endDate'(newVal, oldVal) {
      if (newVal !== oldVal && this.userBehaviorForm.startDate) {
        this.debounceValidateDate('userBehavior');
      }
    },
    
    // 监听订单分析表单的日期变化
    'orderAnalysisForm.startDate'(newVal, oldVal) {
      if (newVal !== oldVal && this.orderAnalysisForm.endDate) {
        this.debounceValidateDate('orderAnalysis');
      }
    },
    'orderAnalysisForm.endDate'(newVal, oldVal) {
      if (newVal !== oldVal && this.orderAnalysisForm.startDate) {
        this.debounceValidateDate('orderAnalysis');
      }
    },
    
    // 监听投诉分析表单的日期变化
    'complaintAnalysisForm.startDate'(newVal, oldVal) {
      if (newVal !== oldVal && this.complaintAnalysisForm.endDate) {
        this.debounceValidateDate('complaintAnalysis');
      }
    },
    'complaintAnalysisForm.endDate'(newVal, oldVal) {
      if (newVal !== oldVal && this.complaintAnalysisForm.startDate) {
        this.debounceValidateDate('complaintAnalysis');
      }
    },
    
    // 监听导出表单的日期变化
    'exportForm.startDate'(newVal, oldVal) {
      if (newVal !== oldVal && this.exportForm.endDate) {
        this.debounceValidateDate('export');
      }
    },
    'exportForm.endDate'(newVal, oldVal) {
      if (newVal !== oldVal && this.exportForm.startDate) {
        this.debounceValidateDate('export');
      }
    }
  },

  methods: {
    // ************************ 公共方法 ************************
    // 页面初始化
    initPage() {
      this.switchTab({ label: this.activeTab });
    },
    
    // 日期格式转换：yyyy-MM-dd → yyyy/MM/dd
    formatDate(date) {
      return date ? date.replace(/-/g, '/') : '';
    },
    
    // 设备ID格式化 - 数组转逗号分隔字符串
    formatDeviceIds(ids) {
      if (!ids || ids.length === 0) return '';
      // 过滤掉空字符串（全部设备选项）
      const validIds = ids.filter(id => id && id !== '');
      return validIds.join(',');
    },
    
    // 获取已选设备数量
    getSelectedDeviceCount() {
      if (!this.deviceForm.deviceIds) return 0;
      // 过滤掉"全部设备"选项
      return this.deviceForm.deviceIds.filter(id => id && id !== '').length;
    },
    
    // 切换标签页
    switchTab(tab) {
      this.activeTab = tab.label;
      this.clearTabData(this.activeTab);
      
      // 切换到设备报表时加载设备列表
      if (this.activeTab === '设备使用周报/月报') {
        this.loadDeviceOptions();
      }
    },
    
    // 清空当前标签页的数据源
    clearTabData(tabLabel) {
      switch (tabLabel) {
        case '设备使用周报/月报':
          this.deviceUsageList = [];
          this.deviceUsageSummary = null;
          break;
        case '用户行为周报/月报':
          this.userBehaviorData = null;
          break;
        case '订单分析周报/月报':
          this.orderAnalysisData = null;
          break;
        case '投诉分析周报/月报':
          this.complaintAnalysisData = null;
          break;
        case '导出综合报表':
          this.exportFileInfo = null;
          break;
      }
    },
    
    // 刷新当前标签页数据
    onRefresh() {
      switch (this.activeTab) {
        case '设备使用周报/月报':
          this.getDeviceUsage();
          break;
        case '用户行为周报/月报':
          this.getUserBehavior();
          break;
        case '订单分析周报/月报':
          this.getOrderAnalysis();
          break;
        case '投诉分析周报/月报':
          this.getComplaintAnalysis();
          break;
        case '导出综合报表':
          this.clearExportForm();
          break;
      }
    },

    // 防抖验证日期
    debounceValidateDate(formType) {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      
      this.debounceTimer = setTimeout(() => {
        this.validateDateRange(formType);
      }, 500);
    },

    // 验证日期范围
    validateDateRange(formType) {
      let query = {};
      
      switch (formType) {
        case 'device':
          if (!this.deviceForm.startDate || !this.deviceForm.endDate) return;
          query = {
            startDate: this.deviceForm.startDate,
            endDate: this.deviceForm.endDate
          };
          break;
        case 'userBehavior':
          if (!this.userBehaviorForm.startDate || !this.userBehaviorForm.endDate) return;
          query = {
            startDate: this.userBehaviorForm.startDate,
            endDate: this.userBehaviorForm.endDate
          };
          break;
        case 'orderAnalysis':
          if (!this.orderAnalysisForm.startDate || !this.orderAnalysisForm.endDate) return;
          query = {
            startDate: this.orderAnalysisForm.startDate,
            endDate: this.orderAnalysisForm.endDate
          };
          break;
        case 'complaintAnalysis':
          if (!this.complaintAnalysisForm.startDate || !this.complaintAnalysisForm.endDate) return;
          query = {
            startDate: this.complaintAnalysisForm.startDate,
            endDate: this.complaintAnalysisForm.endDate
          };
          break;
        case 'export':
          if (!this.exportForm.startDate || !this.exportForm.endDate) return;
          query = {
            startDate: this.exportForm.startDate,
            endDate: this.exportForm.endDate
          };
          break;
        default:
          return;
      }
      
      console.log('验证日期参数：', query);
      
      // 验证日期范围(最大90天)
      const isValid = validateDateRange(
        query,
        (msg) => this.showMessage(msg, 'warning'), // 错误提示函数
        365 // 最大天数
      );
      
      if (!isValid) {
        // 如果日期无效，清空日期
        this.clearInvalidDates(formType);
        this.showMessage('日期范围无效（超过365天或开始日期晚于结束日期），请重新选择', 'warning');
      }
    },

    // 清空无效日期
    clearInvalidDates(formType) {
      switch (formType) {
        case 'device':
          this.deviceForm.startDate = '';
          this.deviceForm.endDate = '';
          break;
        case 'userBehavior':
          this.userBehaviorForm.startDate = '';
          this.userBehaviorForm.endDate = '';
          break;
        case 'orderAnalysis':
          this.orderAnalysisForm.startDate = '';
          this.orderAnalysisForm.endDate = '';
          break;
        case 'complaintAnalysis':
          this.complaintAnalysisForm.startDate = '';
          this.complaintAnalysisForm.endDate = '';
          break;
        case 'export':
          this.exportForm.startDate = '';
          this.exportForm.endDate = '';
          break;
      }
    },

    // ************************ 设备管理接口 ************************
    // 从设备列表中获取设备ID和设备名
    async loadDeviceOptions() {
      try {
        const response = await listDevices(this.deviceQuery);
        const res = response.data;
        if (res && res.code === 0 && res.data) {
          const list = res.data.list || res.data;
          this.deviceOptions = list.map(item => ({ 
            deviceId: item.deviceId, 
            deviceName: item.deviceName 
          }));
        }
      } catch (error) {
        console.error('加载设备列表失败：', error);
      }
    },
    
    // 8.1 获取设备使用统计报表接口
    async getDeviceUsage() {
      this.loading1 = true;
      try {
        // 判断是否选择了"全部设备"
        const hasAllDevice = this.deviceForm.deviceIds.includes('');
        
        let params;
        if (hasAllDevice) {
          // 选择了全部设备，不传deviceIds参数
          params = {
            reportType: this.deviceForm.reportType,
            startDate: this.formatDate(this.deviceForm.startDate),
            endDate: this.formatDate(this.deviceForm.endDate)
          };
        } else {
          // 选择了具体设备，传逗号分隔的设备ID字符串
          params = {
            reportType: this.deviceForm.reportType,
            startDate: this.formatDate(this.deviceForm.startDate),
            endDate: this.formatDate(this.deviceForm.endDate),
            deviceIds: this.formatDeviceIds(this.deviceForm.deviceIds)
          };
        }
        
        console.log('设备使用报表请求参数:', params);
        
        const response = await getDeviceUsageReportAll(params);
        const res = response.data;
        
        console.log('设备使用报表响应:', res.code, res.message, res.data);
        
        if (res.code === 0 && res.data) {
          // 直接从接口获取数据，不进行任何前端过滤和计算
          this.deviceUsageList = this.mapDeviceUsageList(res.data.devices || []);
          this.deviceUsageSummary = this.mapDeviceUsageSummary(res.data.summary);
          this.deviceUsagePeriod = res.data.period || '';
          
          this.showMessage('设备使用报表加载成功！', 'success');
        } else {
          this.showMessage(res?.message || '设备使用报表加载失败', 'error');
          this.deviceUsageList = [];
          this.deviceUsageSummary = null;
        }
      } catch (error) {
        console.error('加载设备使用报表失败：', error);
        this.showMessage('网络错误，加载报表失败', 'error');
        this.deviceUsageList = [];
        this.deviceUsageSummary = null;
      } finally {
        this.loading1 = false;
      }
    },

    // ************************ 设备使用报表 ************************
    // 搜索
    searchDeviceForm(){
      if (!this.deviceForm.reportType) {
        this.showMessage('请选择报表类型！', 'warning');
        return;
      }
      if (!this.deviceForm.startDate || !this.deviceForm.endDate) {
        this.showMessage('请填写起止日期！', 'warning');
        return;
      }
      
      // 验证日期范围
      const query = {
        startDate: this.deviceForm.startDate,
        endDate: this.deviceForm.endDate
      };
      
      const isValid = validateDateRange(
        query,
        (msg) => this.showMessage(msg, 'warning'),
        365
      );
      
      if (!isValid) {
        this.deviceForm.startDate = '';
        this.deviceForm.endDate = '';
        return;
      }
      
      // 设备ID可以为空（全部设备），所以不强制验证
      this.getDeviceUsage();
    },

    // 映射设备使用列表
    mapDeviceUsageList(list) {
      if (!list || !Array.isArray(list)) return [];// 空数组
      return list.map(item => ({
        deviceId: item.deviceId || '',
        deviceNo: item.deviceNo || '',
        deviceName: item.deviceName || '',
        location: item.location || '',
        usageCount: item.usageCount || 0,
        usageTimeMinutes: item.usageTimeMinutes || 0,
        usageRate: item.usageRate || 0,
        faultCount: item.faultCount || 0,
        faultRate: item.faultRate || 0,
        idleTimeMinutes: item.idleTimeMinutes || 0,
        avgUsageDurationMinutes: item.avgUsageDurationMinutes || 0
      }));
    },
    
    // 映射设备使用汇总
    mapDeviceUsageSummary(summary) {
      if (!summary) return null;
      return {
        totalUsageCount: summary.totalUsageCount || 0,
        totalUsageTimeMinutes: summary.totalUsageTimeMinutes || 0,
        avgUsageRate: summary.avgUsageRate || 0,
        totalFaultCount: summary.totalFaultCount || 0,
        avgFaultRate: summary.avgFaultRate || 0
      };
    },

    // 清空设备表单
    clearDeviceForm() {
      this.deviceForm = { 
        reportType: '', 
        deviceIds: [], // 空数组
        startDate: '', 
        endDate: '' 
      };
      this.deviceUsageList = [];
      this.deviceUsageSummary = null;
    },
    
    exportDeviceUsage() {
      if (!this.deviceUsageList.length && !this.deviceUsageSummary) {
        this.showMessage('请先搜索数据再导出', 'warning');
        return;
      }
      this.exportForm = {
        reportCategory: 'DEVICE_USAGE',
        reportType: this.deviceForm.reportType,
        startDate: this.deviceForm.startDate,
        endDate: this.deviceForm.endDate,
        format: 'EXCEL'
      };
      this.exportComprehensiveReport();
    },

    // ************************ 用户行为报表 ************************
    async getUserBehavior() {
      if (!this.userBehaviorForm.reportType) {
        this.showMessage('请选择报表类型！', 'warning');
        return;
      }
      if (!this.userBehaviorForm.startDate || !this.userBehaviorForm.endDate) {
        this.showMessage('请填写起止日期！', 'warning');
        return;
      }
      
      // 验证日期范围
      const query = {
        startDate: this.userBehaviorForm.startDate,
        endDate: this.userBehaviorForm.endDate
      };
      
      const isValid = validateDateRange(
        query,
        (msg) => this.showMessage(msg, 'warning'),
        365
      );
      
      if (!isValid) {
        this.userBehaviorForm.startDate = '';
        this.userBehaviorForm.endDate = '';
        return;
      }
      
      this.loading2 = true;
      try {
        const params = {
          reportType: this.userBehaviorForm.reportType,
          startDate: this.formatDate(this.userBehaviorForm.startDate),
          endDate: this.formatDate(this.userBehaviorForm.endDate)
        };
        const response = await getUserBehaviorReport(params);
        const res = response.data;
        if (res && res.code === 0 && res.data) {
          this.userBehaviorData = res.data;
          this.showMessage('用户行为报表加载成功！', 'success');
        } else {
          this.showMessage(res?.message || '用户行为报表加载失败', 'error');
          this.userBehaviorData = null;
        }
      } catch (error) {
        console.error('加载用户行为报表失败：', error);
        this.showMessage('网络错误，加载报表失败', 'error');
        this.userBehaviorData = null;
      } finally {
        this.loading2 = false;
      }
    },
    
    clearUserBehaviorForm() {
      this.userBehaviorForm = { reportType: '', startDate: '', endDate: '' };
      this.userBehaviorData = null;
    },
    
    exportUserBehavior() {
      if (!this.userBehaviorData) {
        this.showMessage('请先搜索数据再导出', 'warning');
        return;
      }
      this.exportForm = {
        reportCategory: 'USER_BEHAVIOR',
        reportType: this.userBehaviorForm.reportType,
        startDate: this.userBehaviorForm.startDate,
        endDate: this.userBehaviorForm.endDate,
        format: 'EXCEL'
      };
      this.exportComprehensiveReport();
    },
  
    // ************************ 订单分析报表 ************************
    async getOrderAnalysis() {
      if (!this.orderAnalysisForm.reportType) {
        this.showMessage('请选择报表类型！', 'warning');
        return;
      }
      if (!this.orderAnalysisForm.startDate || !this.orderAnalysisForm.endDate) {
        this.showMessage('请填写起止日期！', 'warning');
        return;
      }
      
      // 验证日期范围
      const query = {
        startDate: this.orderAnalysisForm.startDate,
        endDate: this.orderAnalysisForm.endDate
      };
      
      const isValid = validateDateRange(
        query,
        (msg) => this.showMessage(msg, 'warning'),
        365
      );
      
      if (!isValid) {
        this.orderAnalysisForm.startDate = '';
        this.orderAnalysisForm.endDate = '';
        return;
      }
      
      this.loading3 = true;
      try {
        const params = {
          reportType: this.orderAnalysisForm.reportType,
          startDate: this.formatDate(this.orderAnalysisForm.startDate),
          endDate: this.formatDate(this.orderAnalysisForm.endDate)
        };
        const response = await getOrderAnalysisReport(params);
        const res = response.data;
        if (res && res.code === 0 && res.data) {
          this.orderAnalysisData = res.data;
          this.showMessage('订单分析报表加载成功！', 'success');
        } else {
          this.showMessage(res?.message || '订单分析报表加载失败', 'error');
          this.orderAnalysisData = null;
        }
      } catch (error) {
        console.error('加载订单分析报表失败：', error);
        this.showMessage('网络错误，加载报表失败', 'error');
        this.orderAnalysisData = null;
      } finally {
        this.loading3 = false;
      }
    },
    
    clearOrderAnalysisForm() {
      this.orderAnalysisForm = { reportType: '', startDate: '', endDate: '' };
      this.orderAnalysisData = null;
    },
    
    exportOrderAnalysis() {
      if (!this.orderAnalysisData) {
        this.showMessage('请先搜索数据再导出', 'warning');
        return;
      }
      this.exportForm = {
        reportCategory: 'ORDER_ANALYSIS',
        reportType: this.orderAnalysisForm.reportType,
        startDate: this.orderAnalysisForm.startDate,
        endDate: this.orderAnalysisForm.endDate,
        format: 'EXCEL'
      };
      this.exportComprehensiveReport();
    },
 
    // ************************ 投诉分析报表 ************************
    async getComplaintAnalysis() {
      if (!this.complaintAnalysisForm.reportType) {
        this.showMessage('请选择报表类型！', 'warning');
        return;
      }
      if (!this.complaintAnalysisForm.startDate || !this.complaintAnalysisForm.endDate) {
        this.showMessage('请填写起止日期！', 'warning');
        return;
      }
      
      // 验证日期范围
      const query = {
        startDate: this.complaintAnalysisForm.startDate,
        endDate: this.complaintAnalysisForm.endDate
      };
      
      const isValid = validateDateRange(
        query,
        (msg) => this.showMessage(msg, 'warning'),
        365
      );
      
      if (!isValid) {
        this.complaintAnalysisForm.startDate = '';
        this.complaintAnalysisForm.endDate = '';
        return;
      }
      
      this.loading4 = true;
      try {
        const params = {
          reportType: this.complaintAnalysisForm.reportType,
          startDate: this.formatDate(this.complaintAnalysisForm.startDate),
          endDate: this.formatDate(this.complaintAnalysisForm.endDate)
        };
        const response = await getComplaintAnalysisReport(params);
        const res = response.data;
        if (res && res.code === 0 && res.data) {
          this.complaintAnalysisData = res.data;
          this.showMessage('投诉分析报表加载成功！', 'success');
        } else {
          this.showMessage(res?.message || '投诉分析报表加载失败', 'error');
          this.complaintAnalysisData = null;
        }
      } catch (error) {
        console.error('加载投诉分析报表失败：', error);
        this.showMessage('网络错误，加载报表失败', 'error');
        this.complaintAnalysisData = null;
      } finally {
        this.loading4 = false;
      }
    },
    
    clearComplaintAnalysisForm() {
      this.complaintAnalysisForm = { reportType: '', startDate: '', endDate: '' };
      this.complaintAnalysisData = null;
    },
    
    exportComplaintAnalysis() {
      if (!this.complaintAnalysisData) {
        this.showMessage('请先搜索数据再导出', 'warning');
        return;
      }
      this.exportForm = {
        reportCategory: 'COMPLAINT_ANALYSIS',
        reportType: this.complaintAnalysisForm.reportType,
        startDate: this.complaintAnalysisForm.startDate,
        endDate: this.complaintAnalysisForm.endDate,
        format: 'EXCEL'
      };
      this.exportComprehensiveReport();
    },

    // ************************ 综合报表导出 ************************
    async exportComprehensiveReport() {
      if (!this.exportForm.reportCategory) {
        this.showMessage('请选择报表分类！', 'warning');
        return;
      }
      if (!this.exportForm.reportType) {
        this.showMessage('请选择报表类型！', 'warning');
        return;
      }
      if (!this.exportForm.format) {
        this.showMessage('请选择文件格式！', 'warning');
        return;
      }
      if (!this.exportForm.startDate || !this.exportForm.endDate) {
        this.showMessage('请填写起止日期！', 'warning');
        return;
      }
      
      // 验证日期范围
      const query = {
        startDate: this.exportForm.startDate,
        endDate: this.exportForm.endDate
      };
      
      const isValid = validateDateRange(
        query,
        (msg) => this.showMessage(msg, 'warning'),
        365
      );
      
      if (!isValid) {
        this.exportForm.startDate = '';
        this.exportForm.endDate = '';
        return;
      }
      
      this.loading5 = true;
      try {
        const postData = {
          reportCategory: this.exportForm.reportCategory,
          reportType: this.exportForm.reportType,
          startDate: this.formatDate(this.exportForm.startDate),
          endDate: this.formatDate(this.exportForm.endDate),
          format: this.exportForm.format
        };
        const response = await exportReport(postData);
        const res = response.data;
        if (res.code === 0 && res.data) {
          this.exportFileInfo = res.data;
          this.showMessage('报表导出成功！', 'success');
          this.downloadFile();
        } else {
          this.showMessage(res?.message || '报表导出失败', 'error');
          this.exportFileInfo = null;
        }
      } catch (error) {
        console.error('导出报表失败：', error);
        this.showMessage('网络错误，导出报表失败', 'error');
        this.exportFileInfo = null;
      } finally {
        this.loading5 = false;
      }
    },
    
    clearExportForm() {
      this.exportForm = { reportCategory: '', reportType: '', format: '', startDate: '', endDate: '' };
      this.exportFileInfo = null;
    },
    
    downloadFile() {
      if (this.exportFileInfo && this.exportFileInfo.fileUrl) {
        window.open(this.exportFileInfo.fileUrl, '_blank');
      }
    },
    
    // 通用消息提示
    showMessage(message, type = 'info') {
      console.log(`[${type}] ${message}`);
      alert(message);
    }
  }
};
</script>
<style scoped>
/* 完全复用原有样式 */
</style>